import { render, staticRenderFns } from "./m-form-accounting-goods.vue?vue&type=template&id=7d5ef812&scoped=true&lang=pug&"
import script from "./m-form-accounting-goods.vue?vue&type=script&lang=js&"
export * from "./m-form-accounting-goods.vue?vue&type=script&lang=js&"
import style0 from "./m-form-accounting-goods.vue?vue&type=style&index=0&id=7d5ef812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ef812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
